/**
 * Consentimento de cookies de medição/anúncio (LGPD + Consent Mode v2 do Google).
 *
 * A escolha mora num cookie de primeira parte, lido NO BROWSER: o HTML fica
 * em cache no Cloudflare, então o servidor não pode variar por visitante. O
 * script de bootstrap (`buildTrackingBootstrap`) lê o mesmo cookie antes de
 * qualquer tag carregar.
 */
import "./runtime";

export const CONSENT_COOKIE = "b2b_consent";

export type ConsentChoice = "granted" | "denied";

/** Um ano, o teto que a ANPD considera razoável para lembrar a escolha. */
const CONSENT_MAX_AGE = 60 * 60 * 24 * 365;

export function readConsent(cookieString: string): ConsentChoice | null {
    const match = cookieString.match(new RegExp(`(?:^|; )${CONSENT_COOKIE}=([^;]*)`));
    const value = match?.[1];
    return value === "granted" || value === "denied" ? value : null;
}

/** Os quatro sinais do Consent Mode v2 andam juntos: a loja só pede um "aceito". */
export function consentSignals(choice: ConsentChoice): Record<string, ConsentChoice> {
    return {
        ad_storage: choice,
        ad_user_data: choice,
        ad_personalization: choice,
        analytics_storage: choice,
    };
}

/** Grava a escolha e avisa as tags já carregadas — sem recarregar a página. */
export function saveConsent(choice: ConsentChoice): void {
    const secure = window.location.protocol === "https:" ? "; Secure" : "";
    document.cookie = `${CONSENT_COOKIE}=${choice}; Max-Age=${CONSENT_MAX_AGE}; Path=/; SameSite=Lax${secure}`;

    window.gtag?.("consent", "update", consentSignals(choice));
    window.fbq?.("consent", choice === "granted" ? "grant" : "revoke");
    window.dataLayer?.push({ event: "consent_update", consent: choice });
}
